import { skipToken } from '@apollo/client/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { MESSAGES } from '@guuru/chat-common';
import { botMessage, useCurrentChat } from '@guuru/chat-web';
import { useLiveQuery } from '@guuru/react-hooks';
import GET_CHAT_IS_TYPING from './queries/GetChatIsTyping';
import EXPERT_IS_TYPING from './subscriptions/ExpertIsTyping';
import USER_IS_TYPING from './subscriptions/UserIsTyping';

const createIsTypingMessage = (author) => ({
  author,
  metadata: {},
  text: '',
  i18n: '',
  id: crypto.randomUUID(),
  type: MESSAGES.typing,
  createdAt: moment().valueOf(),
});

const { node: botTypingMessage } = botMessage(
  MESSAGES.typing,
  '',
  MESSAGES.typing,
);

export default (options) => {
  const { chatId, isUser } = options === skipToken ? {} : options;
  const [message, setMessage] = useState();
  const { isBotTyping } = useCurrentChat();

  const {
    data: {
      chat: { user = {}, expert = {}, expertIsTyping, userIsTyping } = {},
    } = {},
  } = useLiveQuery(
    GET_CHAT_IS_TYPING,
    isUser ? EXPERT_IS_TYPING : USER_IS_TYPING,
    chatId ? { variables: { chatId } } : skipToken,
  );

  useEffect(() => {
    const uid = isUser ? expert?.id : user?.id;
    if (!uid) return;

    const author = isUser
      ? { ...expert, __typename: 'ExpertAuthor' }
      : { ...user, __typename: 'UserAuthor' };

    const isTypingMessage = createIsTypingMessage(author);
    setMessage(isTypingMessage);
  }, [expert, isUser, user]);

  if (isBotTyping) {
    return botTypingMessage;
  }

  if (!chatId) {
    return null;
  }

  if (isUser && expertIsTyping) {
    return message;
  }

  if (!isUser && userIsTyping) {
    return message;
  }

  return null;
};
